<template>
    <div class="tournaments_container">
        <div class="tabs-selector">
            <div class="tabs-selector-wrapper">
                <div class="tab" :class="{'active':$router.history.current.name=='gamezone'}" @click="enter_online">Turnee online</div>
                <div class="tab" :class="{'active':$router.history.current.name=='offline_tournament'}">Turnee offline</div>
            </div>
        </div>
        <div class="tournaments-container">
            <transition name="component-fade-route" mode="out-in">
                <router-view :key="$route.fullPath"/>
            </transition>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .tournaments-container{
        width: 100%;
        display: inline-block;
        position: relative;
        min-height: 100vh;
    }
</style>
<script>
    import Popup from '@/components/Popup';
    import TournamentsOffline from '@/views/pages/Tournaments/TournamentsOffline.vue';
    import i18n from '@/i18n';

    export default {
        name: "Tournaments",
        components: {
            Popup,
            TournamentsOffline
        },
        data: function () {
            return {
            }
        },
        props: {
        },
        methods: {
            enter_offline(){
                this.$router.push({
                    name:"offline_tournament",
                    params:{
                        locale:i18n.locale,
                    }
                });
            },
            enter_online(){
                this.$router.push("/gamezone/tournament?_="+new Date().getTime());
            }
        }
    }
</script>